import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import UserHome from './home';
import TokenHome from '../Tokens';
import checkUser from '../UserComponent';

class Profile extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired
  };

  render() {
    const { match } = this.props;
    return (
      <div>
        <section className="user-content">
          <Route path={`${match.url}/tokens`} component={TokenHome} />
          <Route exact path={match.url} component={UserHome} />
        </section>
      </div>
    );
  }
}

export default checkUser(Profile);
